import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button, ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { hasPrivilege } from '../../stores/auth/selectors';
import { RootState } from '../../stores/store';
import { selectedSome } from '../../stores/tables/selectors';
import TableToolbar from '../table/TableToolbar';

import AssignApplicationsWorkspaceAction from './actions/AssignApplicationsWorkspaceAction';
import CopyApplicationAction from './actions/CopyApplicationAction';
import DeleteApplicationsAction from './actions/DeleteApplicationsAction';
import SynchronizeUsersAction from './actions/SynchronizeUsersAction';
import AssignApplicationsUsersAction from './actions/AssignApplicationsUsersAction';
import ExportReportAction from './actions/ExportReportAction';

interface Props extends LocalizeContextProps, RouteComponentProps {
    selectedSome: boolean;
    hasPrivilege: (privileges: string[]) => boolean;
}

interface State {
    showActions: boolean;
}

class ApplicationsToolbar extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showActions: false
        };
    }

    public render() {
        const t = this.props.translate;
        return (
            <TableToolbar>
                {this.renderActionMenu()}
                <ExportReportAction />
                <Button
                    color="primary"
                    className="action-btn"
                    onClick={() => {
                        this.props.history.push(`/applications/new`);
                    }}
                >
                    <FontAwesomeIcon
                        className="mr-4"
                        icon={['fal', 'plus']}
                    />
                    {t('applications.button.add')}
                </Button>
            </TableToolbar>
        );
    }

    private renderActionMenu = () => {
        const t = this.props.translate;
        const menuItems = _.compact(this.renderActions());

        if (menuItems.length > 0) {
            return (
                <ButtonDropdown
                    id="action-buttons"
                    className="action-btn"
                    color="default"
                    title={t('applications.button.actions') as string}
                    isOpen={this.state.showActions}
                    toggle={() => { this.setState({ showActions: !this.state.showActions }); }}
                    style={{ marginRight: '10px' }}
                >
                    <DropdownToggle caret={true}>
                        {t('applications.button.actions')}
                    </DropdownToggle>
                    <DropdownMenu persist={true}>
                        {menuItems}
                    </DropdownMenu>
                </ButtonDropdown>
            );
        } else {
            return <div />;
        }
    }

    private renderActions = () => {
        const t = this.props.translate;
        if (this.props.selectedSome) {
            return (
                [
                    <CopyApplicationAction key={1} />, // TODO
                    <AssignApplicationsWorkspaceAction key={2} />, // TODO
                    <AssignApplicationsUsersAction key={3} />,
                    <DeleteApplicationsAction key={4} />, // TODO
                    <SynchronizeUsersAction key={5} />, // TODO
                ]
            );

        } else {
            return [];
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    hasPrivilege: hasPrivilege(state),
    selectedSome: selectedSome(state, 'applications'),
});

export default connect(mapStateToProps)(withLocalize(withRouter(ApplicationsToolbar)));